import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {TechDoc} from '../models';

@Injectable()
export class TechDocService extends IoService {
  protected model = TechDoc;
  protected listUrl = '/pdfs/';
}
